import React, { useRef, useEffect, useState } from 'react';
import gsap from 'gsap';
import './Notificationspage.css';
import AsteriskNav from './Asterisknav';

const NotificationsPage = () => {
    const navRef = useRef(null);
    const tabRef = useRef(null);
    const tabsRef = useRef(null);
    const listRef = useRef(null);
    const emptyRef = useRef(null);

    const [activeTab, setActiveTab] = useState('all');

    const allNotifications = [
        {
            id: 1,
            icon: (
                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                    <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                </svg>
            ),
            iconBg: 'notif-icon-bg--red',
            title: 'Event Reminder',
            desc: 'Design Innovation Summit starts tomorrow at 10:00 AM',
            time: '2 hours ago',
            unread: true,
        },
        {
            id: 2,
            icon: (
                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                </svg>
            ),
            iconBg: 'notif-icon-bg--green',
            title: 'Booking Confirmed',
            desc: 'Your ticket for Architecture & Space has been confirmed',
            time: '1 day ago',
            unread: true,
        },
        {
            id: 3,
            icon: (
                <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
                </svg>
            ),
            iconBg: 'notif-icon-bg--blue',
            title: 'New Event Added',
            desc: 'Check out Creative Typography Workshop',
            time: '2 days ago',
            unread: false,
        },
    ];

    const displayed = activeTab === 'all'
        ? allNotifications
        : allNotifications.filter(n => n.unread);

    useEffect(() => {
        const tl = gsap.timeline({ defaults: { ease: 'power3.out' } });

        gsap.set(navRef.current, { opacity: 0, y: -40 });
        gsap.set(tabRef.current, { opacity: 0, y: 30, scale: 0.97 });
        gsap.set(tabsRef.current, { opacity: 0, x: -20 });

        tl.to(navRef.current, { opacity: 1, y: 0, duration: 0.8 })
          .to(tabRef.current, { opacity: 1, y: 0, scale: 1, duration: 0.65 }, '-=0.4')
          .to(tabsRef.current, { opacity: 1, x: 0, duration: 0.5 }, '-=0.3');
    }, []);

    useEffect(() => {
        if (!listRef.current) return;
        const items = listRef.current.querySelectorAll('.notif-item');
        gsap.fromTo(
            items,
            { opacity: 0, x: 30 },
            { opacity: 1, x: 0, duration: 0.45, stagger: 0.1, ease: 'power3.out' }
        );
    }, [activeTab]);

    return (
        <div className="home-wrapper">
            <div className="mobile-container">
                <div className="notif-screen">

                    <AsteriskNav active="notifications" navRef={navRef} />

                    <main className="notif-sheet" ref={tabRef}>
                        <div className="hp-tab-indicator" aria-hidden="true"></div>

                        <nav className="notif-tabs" ref={tabsRef} aria-label="Notification Filters">
                            <button
                                className={`notif-tab${activeTab === 'all' ? ' notif-tab--active' : ''}`}
                                onClick={() => setActiveTab('all')}
                                aria-pressed={activeTab === 'all'}
                            >
                                ALL
                            </button>
                            <button
                                className={`notif-tab${activeTab === 'unread' ? ' notif-tab--active' : ''}`}
                                onClick={() => setActiveTab('unread')}
                                aria-pressed={activeTab === 'unread'}
                            >
                                UNREAD
                            </button>
                        </nav>

                        <div className="notif-list" ref={listRef} aria-live="polite">
                            {displayed.length > 0 ? (
                                displayed.map(n => (
                                    <article className="notif-item" key={n.id} aria-labelledby={`notif-title-${n.id}`}>
                                        <div className={`notif-icon-wrap ${n.iconBg}`} aria-hidden="true">
                                            {n.icon}
                                        </div>
                                        <div className="notif-body">
                                            <p className="notif-title" id={`notif-title-${n.id}`}>
                                                {n.unread && <span className="sr-only">Unread notification: </span>}
                                                {n.title}
                                            </p>
                                            <p className="notif-desc">{n.desc}</p>
                                            <p className="notif-time"><span className="sr-only">Received </span>{n.time}</p>
                                        </div>
                                        {n.unread && <span className="notif-dot" aria-hidden="true"></span>}
                                    </article>
                                ))
                            ) : (
                                <section className="notif-empty" ref={emptyRef} aria-labelledby="no-notif-title">
                                    <div className="notif-empty-icon" aria-hidden="true">
                                        <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                                            <polyline points="20 6 9 17 4 12"/>
                                            <polyline points="16 6 9 13"/>
                                        </svg>
                                    </div>
                                    <h2 className="notif-empty-text" id="no-notif-title">You're all caught up!</h2>
                                </section>
                            )}
                        </div>

                    </main>
                </div>
            </div>
        </div>
    );
};

export default NotificationsPage;